<!-- selectGame with test layout -->
<template>
  <div class="game-tr-test-select-game" :style="setGameStyle()">
    <div class="overflow-wrappper">
      <div v-if="objectImageExist(mainImage)" class="main-image-container" :style="setMainImageStyle()"></div>
      <div
        class="text-element"
        v-for="(item, index) in textList"
        :key="'text_' + index"
        :style="getTextStyle(item)"
        v-html="item.text"
      ></div>
      <div
        class="question-wrapper"
        v-for="(item, index) in processedQuestionsList"
        :key="'questionList_' + index"
        :style="getQuestionStyle(item)"
      >
        <div class="question-container inner-element-container" :style="getTextBlockStyle('question')">
          <div class="question-text" v-html="item.question"></div>
        </div>
        <div class="answer-container" :style="getTextBlockStyle('answer')">
          <tr-select
            :key="item.id"
            :config="selectConfig(item)"
            :options="item.answers"
            :input-width="inputWidth(item)"
            :input-height="inputHeight(item)"
            :tr-select-value="selected[index]"
            class="select-style"
            @change="setNewValue($event, index)"
          ></tr-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import * as utils from '../../Utils/inputUtils';
import defaultMixin from '../../mixins/defaultMixin';
import TrSelect from '../TrSelect/TrSelect';
export default {
  name: 'tr-test-select-game',
  components: { TrSelect },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  mixins: [defaultMixin],
  data() {
    return {
      mainImage: this.startGameConfig.mainImage,
      // inputWidth: this.startGameConfig.inputWidth,
      // inputHeight: this.startGameConfig.inputHeight,
      questionsList: {},
      textList: {},
      selected: [],
      zoomInnerModal: false,
    };
  },
  created() {},
  beforeMount() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.prepareData();
      this.selected = _.map(this.questionsList, (item) => {
        return {
          correct: item.correct,
          val: '',
          block: false,
          inputStatus: null,
        };
      });
    },
    mixData(elements) {
      let value = elements.items;
      if (elements.shuffle) {
        value = _.shuffle(elements.items);
      }
      if (elements.pick) {
        value = _.take(value, elements.pick);
      }
      return value;
    },
    prepareData() {
      let data = [];
      if (this.startGameConfig.pick && _.isArray(this.startGameConfig.items)) {
        data = _.pick(this.startGameConfig.items);
      } else {
        data = _.take(this.startGameConfig.items);
      }
      data = _.map(data, (elem) => {
        if (_.isArray(elem.answers) && elem.shuffle) {
          elem.answers = _.shuffle(elem.answers);
        }
        return elem;
      });
      /**
       *  first random selection if children has contians items arrray;
       * @method if
       */
      if (data && data[0] && _.isArray(data[0].items)) {
        //  only 1 set can be choose (it's not possible to get two different set simultaneously);
        data = this.mixData(_.cloneDeep(this.startGameConfig))[0];
      }

      data = this.mixData(data);
      let text = _.cloneDeep(this.startGameConfig.staticText);
      this.textList = _.map(text, (item, index) => {
        return Object.assign(item, this.startGameConfig.layoutStaticText[index]);
      });
      this.questionsList = _.map(data, (item, index) => {
        return Object.assign(item, this.startGameConfig.layoutQuestions[index]);
      });
      return data;
    },
    /**
     * test if object objectExist
     * @method objectExist
     * @param  {*}    item testiing element
     * @return {Boolean}         true if is object
     */
    objectImageExist(item) {
      return _.isObject(item) && !_.isNil(item.imagePath);
    },
    getImage(item) {
      return 'static/' + item.imagePath;
      // return 'assets/config/' + item.imagePath;
    },
    selectConfig(item) {
      return _.omit(item, ['pos', 'width', 'height']);
    },
    setNewValue(value, index) {
      let trValue = _.defaults({}, value, {
        correct: undefined,
        val: '',
        block: false,
        inputStatus: null,
      });
      trValue.val = value.text;
      _.assign(this.selected[index], trValue, { val: value });
    },
    getTextStyle(textElement) {
      textElement.offsetVertical = textElement.offsetVertical
        ? textElement.offsetVertical
        : this.startGameConfig.textElementOffsetVertical;
      textElement.offsetHorizontal = textElement.offsetHorizontal
        ? textElement.offsetHorizontal
        : this.startGameConfig.textElementOffsetHorizontal;
      textElement.width = textElement.width ? textElement.width : this.startGameConfig.textElementWidth;
      textElement.height = textElement.height ? textElement.height : this.startGameConfig.textElementHeight;
      return {
        position: 'absolute',
        top: utils.elementTopPosition(textElement.pos.y, textElement.offsetVertical),
        left: utils.elementLeftPosition(textElement.pos.x, textElement.offsetHorizontal),
        width: utils.elementWidth(textElement.width),
        height: utils.elementHeight(textElement.height),
      };
    },
    getTextBlockStyle(type) {
      let width = this.startGameConfig.textBlockWidth;
      if (type === 'question') {
        return {
          width: utils.elementWidth(width),
        };
      }
      return {
        width: utils.elementWidth(this.startGameConfig.questionWidth - width),
      };
    },
    getQuestionStyle(question) {
      question.offsetVertical = question.offsetVertical
        ? question.offsetVertical
        : this.startGameConfig.questionOffsetVertical;
      question.offsetHorizontal = question.offsetHorizontal
        ? question.offsetHorizontal
        : this.startGameConfig.questionOffsetHorizontal;
      question.width = question.width ? question.width : this.startGameConfig.questionWidth;
      question.height = question.height ? question.height : this.startGameConfig.questionHeight;
      return {
        position: 'absolute',
        top: utils.elementTopPosition(question.pos.y, question.offsetVertical),
        left: utils.elementLeftPosition(question.pos.x, question.offsetHorizontal),
        width: utils.elementWidth(question.width),
        height: utils.elementHeight(question.height),
      };
    },
    setGameStyle() {
      return {
        'flex-direction': this.startGameConfig.flexDirection || 'row',
        padding: this.startGameConfig.padding + '%',
        'margin-top': this.startGameConfig.marginTop + '%',
      };
    },
    /**
     * reset all containerEnd without reset reactivity
     * @method resetGameAction
     */
    resetGameAction() {
      /** @type {Boolean} set gameCheckSwitch to false - remove statys icons */
      this.init();
      _.each(this.selected, (item, key, collection) => {
        item.val = '';
        item.text = '';
        item.block = false;
        item.inputStatus = null;
      });
    },
    checkGameAction() {
      let status = _.reduce(
        this.selected,
        (result, value, key) => {
          let temVal = null;
          if (value.correct) {
            temVal = result && true;
            value.block = true;
            value.inputStatus = 'correct';
          } else {
            temVal = false;
            value.block = true;
            value.inputStatus = 'incorrect';
            setTimeout(() => {
              value.val = '';
              value.block = false;
              value.inputStatus = null;
            }, 1000);
          }
          return temVal;
        },
        true
      );
      console.log('ANSWER: ', status);
      if (!status) {
        _.each(this.selected, (item, key) => {
          console.log('item', item);
        });
      }
      return status;
    },
    inputWidth(item) {
      if (item.inputWidth) {
        return item.inputWidth;
      } else if (this.startGameConfig.inputWidth) {
        return this.startGameConfig.inputWidth;
      } else {
        return false;
      }
    },
    textBlockWidth(item) {
      if (item.textBlockWidth) {
        return item.textBlockWidth;
      } else if (this.startGameConfig.textBlockWidth) {
        return this.startGameConfig.textBlockWidth;
      } else {
        return false;
      }
    },
    inputHeight(item) {
      if (item.inputHeight) {
        return item.inputHeight;
      } else if (this.startGameConfig.inputHeight) {
        return this.startGameConfig.inputHeight;
      } else {
        return false;
      }
    },
    processQuestionsList() {
      _.each(_.cloneDeep(this.questionsList), (item, index) => {
        if (item.shuffle) {
          this.questionsList[index].answers = _.shuffle(item.answers);
        }
      });
      this.questionsList = this.questonShuffle ? _.shuffle(this.questionsList) : this.questionsList;
      return this.questionsList;
    },
    setMainImageStyle(mainImage) {
      return {
        'background-image': `url(${this.getImage(mainImage)})`,
        width: `${mainImage.width}px`,
        height: `${mainImage.height}px`,
      };
    },
  },
  computed: {
    processedQuestionsList() {
      return this.processQuestionsList();
    },
    gameStatusMonitor() {
      return this.$store.getters.actualGameStatus;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
$elementWidth: 1478px;
$elementHeight: 153px;
$fontSize: 35px;
%item {
  transition: all 0.5s;
  text-align: center;
  font-size: $fontSize;
  font-family: $gameFontFamily;
  font-style: normal;
  font-variant: normal;
  font-weight: 500;
}
.game-tr-test-select-game {
  width: 100%;
  height: 100%;
  padding-top: 140px;
  padding-bottom: 130px;
  overflow: hidden;
  .overflow-wrappper {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: auto;
    .main-image-container {
      position: relative;
      display: block;
      width: $elementWidth;
      height: $elementHeight;
      margin-bottom: 10px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
    }
    .main-image-zoom-container {
      position: relative;
      display: block;
      width: 1418px;
      height: 1080px;
      margin-bottom: 10px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
    }
  }
}
.text-element {
  background-color: rgba($oddColor, 0.2);
  font-size: $fontSize;
  text-align: left;
  padding: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.question-wrapper {
  // position: relative;
  display: flex;
  // width: 1853px;
  // height: 153px;
  border-radius: 20px;
  border: 3px solid $backgroundControlPanelColor;
  margin-bottom: 20px;

  .question-container {
    width: 1478px;
    border-right: 3px solid $backgroundControlPanelColor;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .question-text {
      padding-left: 35px;
      text-align: left;
    }
  }
  .answer-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 375px;
    .select-style {
      @extend %item;
      margin-left: 10px;
      margin-right: 10px;
      width: 55%;
      height: 70px;
      option {
        @extend %item;
        font-size: 24px !important;
      }
    }
  }
}
</style>
